import dynamic from 'next/dynamic'

export const FeatureSectionV2 = dynamic(() => import('./feature-section-v2'))
